import { FC } from 'react';
import { FormControl, FormLabel } from '@chakra-ui/react';

import { ZeusDatePicker } from 'components/molecules/ZeusDatePicker';

type Props = {
  initialDate: string | null;
  handleChangeDate: (date: string) => void;
};

/**
 * 契約開始日のフォームです。
 * `Form` と名づけていますが、DatePicker 部分はフォームになっていません。
 * バリデーションエラーを詳しく表示させたりするためには react-hook-form の Controller を使ってフォーム化する必要があります。
 */
export const StartDateForm: FC<Props> = ({ initialDate, handleChangeDate }) => {
  const onChange = (date: Date | null) => {
    handleChangeDate(date ? date.toISOString() : '');
  };

  return (
    <FormControl isRequired>
      <FormLabel>契約開始日</FormLabel>
      <ZeusDatePicker
        onChange={onChange}
        initialDate={initialDate ? new Date(initialDate) : null}
      />
    </FormControl>
  );
};
